export const targets = [
	{ selector: "[data-faq='glossary']" },
	{ selector: "[data-faq='normal']" },
] as const;

export async function init() {
	for (const target of targets) {
		const element = document.querySelector(target.selector);
		if (element) {
			const e = await import("./loader.js");
			e.default();
			break;
		}
	}
}
init();
